import "./medication-alerts-list.scss";
import { bindable, bindingMode, autoinject } from "aurelia-framework";
import { Router } from "aurelia-router";
import { IMessageItem } from "../../../interfaces/i-message";

@autoinject
export class MedicationAlertsList {
    @bindable({ defaultBindingMode: bindingMode.toView })
    public medicationAlerts: IMessageItem[] = [];
    @bindable({ defaultBindingMode: bindingMode.toView })
    public conversationId: string = "";
    private _router: Router;

    public constructor(router: Router) {
        this._router = router;
    }

    public handleMenuSelection() {
        this._router.navigate(`/message-center/conversation/${this.conversationId}`);
    }
}
